import { useState, useEffect } from 'react';
import useInstrutorStore from '../../store/useInstrutorStore';
import useUserStore from '../../store/useUserStore';
import Select from '../../components/select';
import { Button, Input } from '../../components/all';
import { ToastContainer } from 'react-toastify';
import { useLocation } from 'react-router-dom';
import useAula from '../../hooks/useAula';
import { addDays, format } from 'date-fns';
import { useNavigate } from 'react-router-dom';
import toast from '../../utils/toast';

export default function CreateAulaWizard() {

  const navigate = useNavigate();
  const { SelectVeicleByInstrutor, SearchAndFilterHour, InsertClass } = useAula();
  const { instrutor } = useInstrutorStore();
  const { usuario } = useUserStore();
  const location = useLocation();
  const { aluno } = location.state || {};

  const categoria = instrutor.tipo_instrutor;
  const categorias = categoria.split("");

  const hoje = format(new Date(), 'yyyy-MM-dd');
  const seteDias = format(addDays(new Date(), 7), 'yyyy-MM-dd');

  const getAutoescolaId = () => {
    const id = sessionStorage.getItem("autoescola_id");
    return id ? parseInt(id) : null;
  };

  const [step, setStep] = useState(1);

  const [selectedTipo, setTipo] = useState('');
  const [selectedVeiculo, setVeiculo] = useState('');
  const [selectedHora, setHora] = useState('');
  const [dataSelecionada, setDataSelecionada] = useState('');

  const [veiculos, setVeiculos] = useState([]);
  const [horas, setHoras] = useState([]);

  const showToast = (type, text1, text2) => {
    toast.dismiss();
    toast[type](`${text1}: ${text2}`);
  };

  /* ============================
     EFFECTS
  ============================ */

  useEffect(() => {
    if (!selectedTipo) return;
    const autoescola_id = getAutoescolaId();

    const searchVeiculos = async () => {
      const response = await SelectVeicleByInstrutor(instrutor.instrutor_id, selectedTipo, autoescola_id);
      setVeiculos(response || []);
    };

    searchVeiculos();
  }, [selectedTipo]);

  useEffect(() => {
    if (!selectedTipo || !selectedVeiculo || !dataSelecionada) return;

    const searchHoras = async () => {
      const veiculoSelecionado = veiculos.find(v => v.placa === selectedVeiculo);
      const idDoVeiculo = veiculoSelecionado?.veiculo_id;
      const response = await SearchAndFilterHour(instrutor.instrutor_id, idDoVeiculo, dataSelecionada);
      setHoras(response || []);
    };

    searchHoras();
  }, [selectedTipo, selectedVeiculo, dataSelecionada]);

  /* ============================
     ACTIONS
  ============================ */

  const next = () => setStep(s => s + 1);
  const back = () => setStep(s => s - 1);

  const createAula = async () => {
    const veiculoSelecionado = veiculos.find(v => v.placa === selectedVeiculo);
    const idDoVeiculo = veiculoSelecionado?.veiculo_id;

    if (!idDoVeiculo) {
      showToast('error', 'Veículo inválido', 'Selecione um veículo válido!');
      return;
    }

    const aula1 = {
      instrutor_id: instrutor.instrutor_id,
      aluno_id: aluno.usuario_id,
      data: dataSelecionada,
      tipo: selectedTipo,
      hora: selectedHora,
      veiculo_id: idDoVeiculo,
      autoescola_id: getAutoescolaId(),
      marcada_por: 2,
      configuracoes: usuario.configuracoes
    };

    const result = await InsertClass(aula1);

    if (result.success) {
      showToast('success', 'Sucesso', 'Aula marcada com sucesso!');
      setStep(1);
      setTipo('');
      setVeiculo('');
      setHora('');
      setDataSelecionada('');
    } else {
      showToast('error', 'Erro ao criar aula', result.error);
    }
  };

  function cancelAula() {
    navigate("/listarAlunosInstrutor");
  }

  /* ============================
     UI
  ============================ */

  return (
    <div className="min-h-[90vh] flex items-center justify-center p-4">
      <div className="w-full max-w-lg rounded-3xl p-6 flex flex-col gap-6 ">
        <Button onClick={cancelAula} type={3} className='!w-fit'>
          <span class="material-icons">
            cancel
          </span>
          Cancelar
        </Button>
        {/* Header */}
        <div className="flex flex-col gap-1">
          <h1 className="text-2xl font-bold text-gray-800">Marcar aula</h1>
          <p className="text-sm text-gray-500">Passo {step} de 5</p>
        </div>

        {/* Aluno fixo */}
        <div className="flex flex-col gap-1">
          <span className="text-xs font-semibold text-gray-500 uppercase">Aluno</span>
          <Input disabled value={`${aluno.nome} ${aluno.sobrenome}`} className="capitalize bg-gray-100" />
        </div>

        {/* ================= STEP 1 ================= */}
        {step === 1 && (
          <>
            <div className="flex flex-col gap-1">
              <span className="text-xs font-semibold text-gray-500 uppercase">Tipo da aula</span>
              <Select
                value={selectedTipo}
                onChange={(e) => setTipo(e.target.value)}
                options={categorias}
                placeholder="Selecione o tipo"
              />
            </div>

            <div className='flex flex-col gap-2'>
              <Button disabled={!selectedTipo} onClick={next}>
                Próximo
                <span className="material-icons">arrow_forward</span>
              </Button>
            </div>
          </>
        )}

        {/* ================= STEP 2 ================= */}
        {step === 2 && (
          <>
            <div className="flex flex-col gap-1">
              <div className='flex justify-end'>
              </div>
              <span className="text-xs font-semibold text-gray-500 uppercase">Veículo</span>
              <Select
                value={selectedVeiculo}
                onChange={(e) => setVeiculo(e.target.value)}
                options={veiculos.map(v => v.placa)}
                placeholder="Selecione o veículo"
              />
            </div>

            <div className='flex flex-col gap-2'>
              <Button disabled={!selectedVeiculo} onClick={next}>
                Próximo
                <span className="material-icons">arrow_forward</span>
              </Button>
              <Button type={5} onClick={back}>
                <span className="material-icons">arrow_back</span>
                Voltar
              </Button>
            </div>
          </>
        )}

        {/* ================= STEP 3 ================= */}
        {step === 3 && (
          <>
            <div className="flex flex-col gap-1">
              <span className="text-xs font-semibold text-gray-500 uppercase">Data</span>
              <Input
                type="date"
                min={hoje}
                max={seteDias}
                value={dataSelecionada}
                onChange={e => setDataSelecionada(format(addDays(new Date(e.target.value), 1), 'yyyy-MM-dd'))}
              />

              <div className="flex gap-3 mt-2">
                <Button type={5} onClick={() => setDataSelecionada(format(new Date(), 'yyyy-MM-dd'))}>
                  Hoje
                </Button>
                <Button type={5} onClick={() => setDataSelecionada(format(addDays(new Date(), 1), 'yyyy-MM-dd'))}>
                  Amanhã
                </Button>
              </div>
            </div>

            <div className='flex flex-col gap-2'>
              <Button disabled={!dataSelecionada} onClick={next}>
                Próximo
                <span className="material-icons">arrow_forward</span>
              </Button>
              <Button type={5} onClick={back}>
                <span className="material-icons">arrow_back</span>
                Voltar
              </Button>
            </div>
          </>
        )}

        {/* ================= STEP 4 ================= */}
        {step === 4 && (
          <>
            <div className="flex flex-col gap-1">
              <span className="text-xs font-semibold text-gray-500 uppercase">Horário</span>
              <Select
                value={selectedHora}
                onChange={(e) => setHora(e.target.value)}
                options={horas}
                placeholder="Selecione o horário"
              />
            </div>

            <div className='flex flex-col gap-2'>
              <Button disabled={!selectedHora} onClick={next}>
                Próximo
                <span className="material-icons">arrow_forward</span>
              </Button>
              <Button type={5} onClick={back}>
                <span className="material-icons">arrow_back</span>
                Voltar
              </Button>
            </div>
          </>
        )}

        {/* ================= STEP 5 ================= */}
        {step === 5 && (
          <>
            <div className="bg-gray-50 p-4 rounded-xl flex flex-col gap-2 text-sm justify-start items-start">
              <p><b>Aluno:</b> {aluno.nome} {aluno.sobrenome}</p>
              <p><b>Tipo:</b> {selectedTipo}</p>
              <p><b>Veículo:</b> {selectedVeiculo}</p>
              <p><b>Data:</b> {format(addDays(new Date(dataSelecionada), 1), 'dd/MM/yyyy')}</p>
              <p><b>Hora:</b> {selectedHora}</p>
            </div>

            <div className="flex gap-3 flex-col">
              <Button onClick={createAula}>
                Finalizar agendamento
                <span className="material-icons">check</span>
              </Button>
              <Button type={5} onClick={back}>
                <span className="material-icons">arrow_back</span>
                Voltar
              </Button>
            </div>
          </>
        )}

        <div className="h-10" />
      </div>

      <ToastContainer position="top-center" />
    </div>
  );
}
